export const getLoginRouteByPlatform = (platform) => {
  switch (platform) {
    case 'fctg':
      return '/fctg-sign-in';
    default:
      return '/fctg-sign-in';
  }
};
